"use client";

import type { ExperienceConfiguration } from "@ninetailed/experience.js-react";
import type { BannerVariantData } from "@/lib/ninetailed/mapBannerExperiences";
import { AnnouncementBannerView } from "./AnnouncementBannerView";
import { PersonalizedEntry } from "./PersonalizedEntry";

interface Props {
  baseline: BannerVariantData;
  experiences: ExperienceConfiguration<BannerVariantData>[];
  exposures: Record<string, number>;
}

export function PersonalizedAnnouncementBanner({ baseline, experiences, exposures }: Props) {
  return (
    <PersonalizedEntry
      baseline={baseline}
      experiences={experiences}
      exposures={exposures}
      view={AnnouncementBannerView}
    />
  );
}
